const getNodeUrl = () => {
  const randomIndex = 'https://mainnet.infura.io/v3/e1a93b9201f84df6a0863b9efcd50c1a'
  return randomIndex
}

export default getNodeUrl
